import { createSlice } from "@reduxjs/toolkit";
import {
  initialNoticeState,
  noticeReducers,
} from "@timeedit/registration-components";

export const noticeSlice = createSlice({
  name: "notice",
  initialState: initialNoticeState,
  reducers: noticeReducers,
});

export const { setMessage, setNotification } = noticeSlice.actions;
